var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/retransmission-prefix';
import http from 'app/services/http';
const initialState = {
    prefixes: [],
    transportPrefixes: [],
    transportPrefixesTransportId: null,
    transportPrefixesGroupId: null,
    isLoading: false,
    error: null,
};
export const retransmissionPrefixReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_PREFIXES: {
            const { prefixes } = action.payload;
            return Object.assign(Object.assign({}, state), { prefixes: prefixes });
        }
        case actions.ADD_PREFIX: {
            const { prefix } = action.payload;
            return Object.assign(Object.assign({}, state), { prefixes: [...state.prefixes, prefix] });
        }
        case actions.UPDATE_PREFIX: {
            const { prefix } = action.payload;
            return Object.assign(Object.assign({}, state), { prefixes: state.prefixes.map((p) => (p.id === prefix.id ? prefix : p)) });
        }
        case actions.REMOVE_PREFIX: {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { prefixes: state.prefixes.filter((p) => p.id !== id) });
        }
        case actions.SET_LOADING: {
            const { isLoading } = action.payload;
            return Object.assign(Object.assign({}, state), { isLoading: isLoading });
        }
        case actions.SET_ERROR: {
            const { error } = action.payload;
            return Object.assign(Object.assign({}, state), { error: error });
        }
        case actions.SET_TRANSPORT_PREFIXES: {
            const { prefixes, transportId, groupId } = action.payload;
            return Object.assign(Object.assign({}, state), { transportPrefixes: prefixes, transportPrefixesTransportId: transportId, transportPrefixesGroupId: groupId });
        }
        default:
            return state;
    }
};
// Thunks
function isCurrentTransportSelection(getState, transportId, groupId) {
    var _a;
    const selected = (_a = getState().transport) === null || _a === void 0 ? void 0 : _a.selectedItem;
    return (selected === null || selected === void 0 ? void 0 : selected.id) === transportId && (selected === null || selected === void 0 ? void 0 : selected.group_id) === groupId;
}
export function prefixLoadByTransport(transportId) {
    return function prefixLoadByTransportThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!transportId) {
                dispatch(actions.setTransportPrefixes([], null, null));
                return { success: true };
            }
            const groupId = (_c = (_b = (_a = getState().transport) === null || _a === void 0 ? void 0 : _a.selectedItem) === null || _b === void 0 ? void 0 : _b.group_id) !== null && _c !== void 0 ? _c : null;
            try {
                const response = yield http.get(`/retransmission-prefix/transport/${transportId}`);
                // Игнорируем ответ, если сменились ТС или группа (префиксы завязаны на group_id).
                if (!isCurrentTransportSelection(getState, transportId, groupId)) {
                    return { success: true };
                }
                dispatch(actions.setTransportPrefixes(response.data || [], transportId, groupId));
                return { success: true };
            }
            catch (error) {
                if (!isCurrentTransportSelection(getState, transportId, groupId)) {
                    return { success: false, error };
                }
                dispatch(actions.setTransportPrefixes([], transportId, groupId));
                return { success: false, error };
            }
        });
    };
}
export function prefixLoad() {
    return function prefixLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            dispatch(actions.setLoading(true));
            try {
                const response = yield http.get('/retransmission-prefix');
                dispatch(actions.setPrefixes(response.data));
                dispatch(actions.setError(null));
                return { success: true };
            }
            catch (error) {
                dispatch(actions.setError(error.message));
                return { success: false, error };
            }
            finally {
                dispatch(actions.setLoading(false));
            }
        });
    };
}
export function prefixCreate(data) {
    return function prefixCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield http.post('/retransmission-prefix', data);
                dispatch(actions.addPrefix(response.data));
                return { success: true, data: response.data };
            }
            catch (error) {
                return { success: false, error };
            }
        });
    };
}
export function prefixUpdate(id, data) {
    return function prefixUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield http.put(`/retransmission-prefix/${id}`, data);
                dispatch(actions.updatePrefixAction(response.data));
                return { success: true, data: response.data };
            }
            catch (error) {
                return { success: false, error };
            }
        });
    };
}
export function prefixDelete(id) {
    return function prefixDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield http.delete(`/retransmission-prefix/${id}`);
                dispatch(actions.removePrefix(id));
                return { success: true };
            }
            catch (error) {
                return { success: false, error };
            }
        });
    };
}
export default retransmissionPrefixReducer;
